import { AccordionContainer } from "../../../../../common/components/accordion/accordion.module"
import { InputContainer } from "../../../../../common/components/form/input/containers/input.container"


export const DbaRegistriesKeypairInfoComponent = ({ handleBacicInnerFormChange, selectedDbnpRegistry }: any) => (
    <>
        <AccordionContainer
            child={
                <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                        isDisabled
                        label="Signing Unique Key"
                        name="signing_unique_key_id"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'signing_unique_key_id',
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.signing_unique_key_id}
                    />
                    <InputContainer
                        isDisabled
                        label="Signing Private Key"
                        name="signing_private_key"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'signing_private_key',
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.signing_private_key}
                    />
                    <InputContainer
                        isDisabled
                        label="Signing Public Key"
                        name="signing_public_key"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'signing_public_key',
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.signing_public_key}
                    />
                    <InputContainer
                        isDisabled
                        label="Signing Valid From"
                        name="signing_valid_from"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'signing_valid_from'
                            )
                        }}
                        type="date"
                        value={selectedDbnpRegistry?.signing_valid_from}
                    />
                    <InputContainer
                        isDisabled
                        label="Signing Valid Until"
                        name="signing_valid_until"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'signing_valid_until'
                            )
                        }}
                        type="date"
                        value={selectedDbnpRegistry?.signing_valid_until}
                    />
                </div>
            }
            expandedPanel="Signed KeyPair Info"
            headerTitle="Signed KeyPair Info"
        />
        <AccordionContainer
            child={
                <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                        isDisabled
                        label="Encryption Private Key"
                        name="encryption_private_key"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'encryption_private_key',
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.encryption_private_key}
                    />
                    <InputContainer
                        isDisabled
                        label="Encryption Public Key"
                        name="encryption_public_key"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'encryption_public_key',
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.encryption_public_key}
                    />
                    <InputContainer
                        isDisabled
                        label="Encryption Valid From"
                        name="encryption_valid_from"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'encryption_valid_from'
                            )
                        }}
                        type="date"
                        value={selectedDbnpRegistry?.encryption_valid_from}
                    />
                    <InputContainer
                        isDisabled
                        label="Encryption Valid Until"
                        name="encryption_valid_until"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'encryption_valid_until'
                            )
                        }}
                        type="date"
                        value={selectedDbnpRegistry?.encryption_valid_until}
                    />
                </div>
            }
            expandedPanel="Encrypted KeyPair Info"
            headerTitle="Encrypted KeyPair Info"
        />
    </>
)

export default DbaRegistriesKeypairInfoComponent;